import ooeConstants from '../constants';
import { capitalizeFirstLetter } from '../util/format';
import { DiagnosticMessageEntity, DiagnosticMessageType } from './types';

export const getMessageType = (error: string): DiagnosticMessageType => {
  const className = error.split(':')[0].toLowerCase();
  return className === 'warning' ? DiagnosticMessageType.warning : DiagnosticMessageType.error;
};

export const isDimissible = (error: string) => error.includes(ooeConstants.DISMISSIBLE);

export const formatToMessageText = (error: string) =>
  capitalizeFirstLetter(error.replace(ooeConstants.DISMISSIBLE, ''));

export const mapErrorsToDiagnosticMessages = (errors: Record<string, string>): DiagnosticMessageEntity[] =>
  Object.entries(errors).map(([id, text]) => ({
    id,
    type: getMessageType(text),
    text: formatToMessageText(text),
    dismissible: isDimissible(text),
  }));
